import { ActionType } from '../constants/ActionType';
import { Action } from 'redux';
import { AuthState } from '../reducers/Auth';

export interface SetSignInRedirectAction extends Action<ActionType.SET_SIGN_IN_REDIRECT> {
  type: ActionType.SET_SIGN_IN_REDIRECT;
  redirect: string;
  redirectQueryParams?: string;
}

export const setSignInRedirect = (redirect: string, redirectQueryParams?: string) => {
  return {
    type: ActionType.SET_SIGN_IN_REDIRECT,
    redirect,
    redirectQueryParams,
  };
};

export type UpdateAuthStateRequest = Partial<Omit<AuthState, 'redirect' | 'redirectQueryParams'>>;

export type UpdateAuthState = Action<ActionType.UPDATE_AUTH_STATE> & UpdateAuthStateRequest;

export const updateAuthState = (request: UpdateAuthStateRequest): UpdateAuthState => {
  return {
    type: ActionType.UPDATE_AUTH_STATE,
    ...request,
  };
};

export interface SignOutAction extends Action<ActionType.SIGNOUT> {
  type: ActionType.SIGNOUT;
}

export const signOut = (): SignOutAction => {
  return {
    type: ActionType.SIGNOUT,
  };
};

export interface ShowAuthMessageAction extends Action<ActionType.SHOW_AUTH_MESSAGE> {
  type: ActionType.SHOW_AUTH_MESSAGE;
  message: string;
}

export const showAuthMessage = (message: string): ShowAuthMessageAction => {
  return {
    type: ActionType.SHOW_AUTH_MESSAGE,
    message,
  };
};

export interface HideAuthMessageAction extends Action<ActionType.HIDE_AUTH_MESSAGE> {
  type: ActionType.HIDE_AUTH_MESSAGE;
}

export const hideAuthMessage = (): HideAuthMessageAction => {
  return {
    type: ActionType.HIDE_AUTH_MESSAGE,
  };
};

export interface ShowLoadingAction extends Action<ActionType.SHOW_LOADING> {
  type: ActionType.SHOW_LOADING;
}

export const showLoading = (): ShowLoadingAction => {
  return {
    type: ActionType.SHOW_LOADING,
  };
};

export interface HideLoadingAction extends Action<ActionType.HIDE_LOADING> {
  type: ActionType.HIDE_LOADING;
}

export const hideLoading = (): HideLoadingAction => {
  return {
    type: ActionType.HIDE_LOADING,
  };
};

export type AuthAction =
  | SetSignInRedirectAction
  | UpdateAuthState
  | SignOutAction
  | ShowAuthMessageAction
  | HideAuthMessageAction
  | ShowLoadingAction
  | HideLoadingAction;
